import { isNone } from '@ember/utils';

// This isn't the proto because it has underscored attributes

// TODO(lenny) this shouldn't exist inside squareup/common since it
// does JS-specific magic.
// Use `import { YearMonthDay } from '@square/dashboard-data/models/squareup/common/time';` for
// a plain proto-friendly object.
export default {
  serialize(date) {
    if (!isNone(date)) {
      return {
        year: date.getFullYear(),
        month_of_year: date.getMonth() + 1,
        day_of_month: date.getDate()
      };
    }
    return undefined;
  },
  deserialize(proto) {
    if (!isNone(proto)) {
      return new Date(proto.year, proto.month_of_year - 1, proto.day_of_month);
    }
    return undefined;
  }
};